import { render, staticRenderFns } from "./modalwindow.vue?vue&type=template&id=661d63d1&scoped=true&"
import script from "./modalwindow.vue?vue&type=script&lang=js&"
export * from "./modalwindow.vue?vue&type=script&lang=js&"
import style0 from "./modalwindow.vue?vue&type=style&index=0&id=661d63d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d63d1",
  null
  
)

export default component.exports